import axios from 'api/axios'
import { useCallback, useEffect, useState } from 'react'

/**
 * Hook para obtener el listado de planificaciones
 * @returns {Object} { response, count, error, loading, refetch }
 */

const useFetchPlanificaciones = () => {
  const [response, setResponse] = useState([])
  const [count, setCount] = useState(0)
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)

  const fetchData = useCallback(() => {
    setLoading(true)
    setError(null)

    axios
      .get('/planificaciones/')
      .then((request_response) => {
        const data = request_response.data
        setResponse(data.results || data)
        setCount(data.count || data.length)
      })
      .catch((err) => setError(err))
      .finally(() => setLoading(false))
  }, [])

  useEffect(() => {
    fetchData()
  }, [])

  return { response, count, error, loading, refetch: fetchData }
}

export default useFetchPlanificaciones
